import React from 'react'
import { useQuery } from '@moonpig/web-core-graphql'
import {
  GetUpsellProductQuery,
  GetUpsellProductQueryVariables,
  GetUpsellProductGQL,
} from '../../queries/getUpsellProduct'
import { ProductContext, ProductInfoProduct } from '../../types'
import { ConciergeProductModalComponent } from './ConciergeProductModalComponent'
import { ConciergeProductModalProviders } from './ConciergeProductModalProviders'
import { Heading } from '@moonpig/launchpad-components'

type ConciergeProductModalProps = {
  selectedProductId: string | null
  onAddToBasket?: ProductContext['onAddToBasket']
}
export const ConciergeProductModal = ({
  selectedProductId,
  onAddToBasket,
}: ConciergeProductModalProps) => {
  const {
    data: productData,
    loading,
    error,
  } = useQuery<GetUpsellProductQuery, GetUpsellProductQueryVariables>(
    GetUpsellProductGQL,
    {
      variables: {
        productId: selectedProductId || '',
      },
      skip: !selectedProductId,
    },
  )

  const product = productData?.productLookup?.products[0] as
    | ProductInfoProduct
    | undefined

  if (!selectedProductId) {
    return null
  }

  if (loading) {
    return (
      <Heading level="h6" mt={3} mx={3} textAlign="center">
        Loading...
      </Heading>
    )
  }

  if (error) {
    return (
      <Heading level="h6" mt={3} mx={3} textAlign="center">
        Error loading product. API response error
      </Heading>
    )
  }

  if (!product) {
    return (
      <Heading level="h6" mt={3} mx={3} textAlign="center">
        Error loading product. No product in response
      </Heading>
    )
  }

  return (
    <ConciergeProductModalProviders
      product={product}
      onAddToBasket={onAddToBasket}
    >
      <ConciergeProductModalComponent />
    </ConciergeProductModalProviders>
  )
}
